document.addEventListener('DOMContentLoaded', () => {
  const productJson = document.querySelector('[type="application/json"][id^="ProductJson"]');
  if (!productJson) return;

  const product = JSON.parse(productJson.textContent);
  const optionInputs = document.querySelectorAll('[name="options[]"]');

  function getSelectedOptions() {
    return Array.from(optionInputs).map(input => {
      if (input.type === 'radio') {
        return document.querySelector(`[name="options[]"][value="${input.value}"]:checked`)?.value;
      }
      return input.value;
    });
  }

  function findVariant() {
    const selected = getSelectedOptions();
    return product.variants.find(v =>
      v.options.every((opt, i) => opt === selected[i])
    );
  }

  function setActiveMediaByVariant(variant) {
    if (!variant || !variant.featured_media) return;

    const mediaId = String(variant.featured_media.id);

    // Buscar slide que contenga el mediaId
    const slides = [...document.querySelectorAll('[data-media-id]')];
    const index = slides.findIndex(el =>
      el.getAttribute('data-media-id')?.includes(mediaId)
    );

    if (index === -1) return;

    // Swiper instance (el tema la expone en el contenedor)
    const swiperEl = document.querySelector('.swiper, .swiper-container');
    const swiper = swiperEl?.swiper;

    if (swiper && typeof swiper.slideTo === 'function') {
      swiper.slideTo(index);
    }
  }

  function updateURL(variant) {
    if (!variant) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function onVariantChange() {
    const variant = findVariant();
    if (!variant) return;

    setActiveMediaByVariant(variant);
    updateURL(variant);
  }

  optionInputs.forEach(el => {
    el.addEventListener('change', onVariantChange);
  });

  onVariantChange();
});
